import { render, staticRenderFns } from "./TablaCuentasApartados.vue?vue&type=template&id=bed75178&"
import script from "./TablaCuentasApartados.vue?vue&type=script&lang=js&"
export * from "./TablaCuentasApartados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports